
import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

export const SessionTimeoutModal = ({showModal, handleContinue, handleLogout, remainingTime}) => {

    return (
        <Modal show={showModal} onHide={handleContinue}>
            <Modal.Header closeButton>
            <Modal.Title>Session expired!</Modal.Title>
            </Modal.Header>
            <Modal.Body>Your session has timed out. Do You want to stay?</Modal.Body>
            <Modal.Footer>
            <Button variant="danger" onClick={handleLogout}>
                Logout
            </Button>
            <Button variant="primary" onClick={handleContinue}>
                Continue Session
            </Button>
            </Modal.Footer>
        </Modal>
    )
}